var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Weekly Recap",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.retryLoading, "z-index": "999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "soli-subtitle" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.globalMomentDate(
                                        _vm.rangeStart
                                      )} to ${_vm.globalMomentDate(
                                        _vm.rangeEnd
                                      )}`
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.weeklyLocationReport,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                    },
                    on: {
                      "click:row": function ($event) {
                        ;[(_vm.showDetails = true), (_vm.details = $event)]
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.net`,
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    item.enrollments.length -
                                      item.withdrawals.length
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.$vuetify.breakpoint.xs ? true : false,
            "content-class": _vm.$vuetify.breakpoint.xs ? "" : "soli-round",
            transition: _vm.$vuetify.breakpoint.smAndDown
              ? "dialog-bottom-transition"
              : "dialog-transition",
            "max-width": "600px",
          },
          on: {
            "click:outside": function ($event) {
              _vm.showDetails = null
            },
          },
          model: {
            value: _vm.showDetails,
            callback: function ($$v) {
              _vm.showDetails = $$v
            },
            expression: "showDetails",
          },
        },
        [
          _vm.details
            ? _c(
                "v-card",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-3 soli-close soli-grey soli-text-shadow",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showDetails = null
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-title", [
                    _vm._v(_vm._s(`${_vm.details.location} Details`)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { staticClass: "pt-0 px-5" },
                    _vm._l(_vm.getDetails, function (item) {
                      return _c(
                        "v-list",
                        {
                          key: item.title,
                          attrs: { dense: "", subheader: "" },
                        },
                        [
                          _c("v-subheader", [_vm._v(_vm._s(item.title))]),
                          _vm._v(" "),
                          _vm._l(item.value, function (name, idx) {
                            return _c(
                              "v-list-item",
                              { key: idx, attrs: { dense: "" } },
                              [_vm._v(_vm._s(name))]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }